import { render, staticRenderFns } from "./KabKepulauanYapen.vue?vue&type=template&id=5e84d322"
import script from "./KabKepulauanYapen.vue?vue&type=script&lang=js"
export * from "./KabKepulauanYapen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports